import { Box, Button, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { Modal, TextField, Typography } from "@mui/material";
import { styles } from "../../pages/TeamManagement/styles";
import { useContext, useState } from "react";
import { APP_COLOR, APP_HOVER_COLOR, BUTTON_TEXT_COLOR } from "../../theme";
import { TEXT_COLOR } from "../../theme";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { CustomPaper, SelectField } from "../../pages/MyTracks/styles";
import { useStyles } from "../../pages/MyTracks/styles";
import { addEnterpriseMemberModalStyles } from "./styles";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { updateEnterpriseMember } from "../../services/enterpriseService";
import { toast } from "react-toastify";
import {
  GetUserResponse,
  UpdateMemberOfEnterpriseResponse,
} from "../../proto/api_pb";
import { EnterpriseDetails, User } from "../../proto/api_pb";
import { UserDetailsContext } from "../../contexts";
import EditIcon from "@mui/icons-material/Edit";
import { getRoleString } from "../../pages/Projects/types";
import { useNavigate } from "react-router-dom";

export interface EditEnterpriseMemberRoleProps {
  member: User;
  getTeamMembers: () => Promise<void>;
  enterpriseDetails: EnterpriseDetails | undefined;
  currentUser: GetUserResponse | undefined;
}

export const EditEnterpriseMemberRole: React.FC<
  EditEnterpriseMemberRoleProps
> = ({ member, getTeamMembers, enterpriseDetails, currentUser }) => {
  const [open, setOpen] = useState(false);
  const [role, setRole] = useState<string>(
    getRoleString(Number(enterpriseDetails?.getRole()))
  );
  const { enterprise } = useContext(UserDetailsContext);
  const { getValidAccessToken } = useGetValidAccessToken();
  const classes = useStyles();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const handleOpen = () => setOpen(true);
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
    setRole(getRoleString(Number(enterpriseDetails?.getRole())));
  };

  const handleSubmit = async () => {
    const token = await getValidAccessToken();
    const res = await updateEnterpriseMember(
      token,
      member.getEmail(),
      enterprise?.id ?? "",
      role
    );
    if (res instanceof UpdateMemberOfEnterpriseResponse) {
      toast.info("Member updated successfully");
      await getTeamMembers();
      navigate(0);
      if (member.getEmail() === currentUser?.getEmail()) {
        sessionStorage.clear();
        window.location.href = "/select-enterprise";
      }
      handleClose();
    } else {
      console.log(res);
    }
  };

  return (
    <>
      <Tooltip placement="top" title="Edit Member Role">
        <IconButton onClick={handleOpen}>
          <EditIcon style={{ color: "#94969C" }} />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...addEnterpriseMemberModalStyles.modal,
            width: isSmallScreen ? "100%" : "auto",
          }}
        >
          <Box sx={addEnterpriseMemberModalStyles.updateRoleContainer}>
            <Box>
              <Box sx={addEnterpriseMemberModalStyles.addPersonIconContainer}>
                <PersonAddAlt1Icon />
              </Box>
              <Typography
                variant="h6"
                sx={addEnterpriseMemberModalStyles.heading}
              >
                Update Role
              </Typography>
            </Box>
            <IconButton sx={{ height: "40px" }} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={addEnterpriseMemberModalStyles.detailsContainer}>
            <Box>
              <Typography sx={{ color: TEXT_COLOR }}>Member Email</Typography>
              <TextField
                disabled
                value={member.getEmail()}
                sx={{ width: "280px" }}
                placeholder="Add Email"
              />
            </Box>
            <Box>
              <Typography sx={{ color: TEXT_COLOR }}>Select Role</Typography>
              <SelectField
                style={{ width: "280px" }}
                options={["Artist", "Manager", "Admin"]}
                value={role}
                onChange={(_e, value) => {
                  setRole(value as string);
                }}
                renderInput={(params: any) => (
                  <TextField
                    sx={{
                      width: "280px",
                      "& .MuiInputLabel-root": {
                        color: "gray",
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "gray",
                      },
                    }}
                    {...params}
                    label={
                      !params.InputProps?.focused && !role ? "Select Role" : ""
                    }
                    InputLabelProps={{ shrink: false }}
                    classes={{ root: classes.customTextField }}
                  />
                )}
                PaperComponent={CustomPaper}
              />
            </Box>
          </Box>
          <Box sx={addEnterpriseMemberModalStyles.buttonContainer}>
            <Button
              sx={{
                ...styles.button,
                backgroundColor: APP_COLOR,
                "&:hover": {
                  backgroundColor: APP_HOVER_COLOR,
                },
                color: BUTTON_TEXT_COLOR,
              }}
              onClick={handleSubmit}
            >
              Add Member
            </Button>
            <Button onClick={handleClose} sx={styles.button}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
